// Placeholder for routes that the Landing links to but we haven't built
// yet (login, register, privacy, terms). Better than a NotFound 404 —
// gives the user something pleasant + a way back.
//
// Auto-detects role from ?role=customer|recipient|merchant so the
// register CTA copy reads correctly per persona.

import { Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft, ShoppingBag } from 'lucide-react';

interface Props {
  title: string;
  body: string;
  showRoleBadge?: boolean;
}

export function ComingSoon({ title, body, showRoleBadge }: Props) {
  const [params] = useSearchParams();
  const role = params.get('role');
  return (
    <div className="min-h-screen bg-[var(--color-panel)]">
      <header className="bg-white border-b border-[var(--color-hairline)]">
        <div className="mx-auto max-w-3xl px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-gradient-to-br from-brand-500 to-brand-700 text-white">
              <ShoppingBag className="w-4 h-4" />
            </span>
            <span className="font-semibold tracking-tight">VoyeLakay</span>
          </Link>
          <Link to="/" className="inline-flex items-center gap-1.5 text-[13px] text-[var(--color-secondary)] hover:text-[var(--color-ink)]">
            <ArrowLeft className="w-3.5 h-3.5" /> Back
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-2xl px-6 py-24">
        {showRoleBadge && role && (
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-50 text-brand-700 text-[11px] uppercase tracking-wider font-semibold">
            Role: {role}
          </span>
        )}
        <h1 className="mt-4 text-3xl md:text-4xl font-semibold tracking-tight text-[var(--color-ink)]">{title}</h1>
        <p className="mt-4 text-[16px] text-[var(--color-secondary)] leading-relaxed">{body}</p>

        <div className="mt-8 flex gap-3 flex-wrap">
          <Link to="/" className="inline-flex items-center px-5 py-2.5 rounded-full bg-[var(--color-ink)] text-white text-[13px] font-semibold hover:bg-[var(--color-primary)]">
            Back to home
          </Link>
          <a href="mailto:hello@lakaycart.com" className="inline-flex items-center px-5 py-2.5 rounded-full border border-[var(--color-border)] text-[var(--color-body)] text-[13px] font-semibold hover:bg-white">
            Get notified
          </a>
        </div>
      </main>
    </div>
  );
}
